import { PersonsItem } from './PersonsItem';
import { determineMissingRoles } from '../../../types/DetermineMissingRoles';
export const Persons = {
    items: PersonsItem,
    min: 1,
    max: 100,
    // @ts-expect-error: FIXME
    determineMissingRoles: (payload) => determineMissingRoles(payload),
};
